import { type ComponentProps } from "react";

const OptimisationIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg
      width="25"
      height="27"
      viewBox="0 0 25 27"
      fill="currentColor"
      {...props}
    >
      <path d="M7.74015 5.31231L4.76431 6.98932L6.43078 3.99466L4.76431 1L7.74015 2.67701L10.716 1L9.04952 3.99466L10.716 6.98932L7.74015 5.31231ZM22.0242 17.0514L25 15.3744L23.3335 18.369L25 21.3637L22.0242 19.6867L19.0483 21.3637L20.7148 18.369L19.0483 15.3744L22.0242 17.0514ZM25 1L23.3335 3.99466L25 6.98932L22.0242 5.31231L19.0483 6.98932L20.7148 3.99466L19.0483 1L22.0242 2.67701L25 1ZM14.6917 13.913L17.5961 10.9902L15.0726 8.45072L12.1682 11.3735L14.6917 13.913ZM15.9177 7.3367L18.7031 10.1397C19.1674 10.5829 19.1674 11.3615 18.7031 11.8287L4.81193 25.8078C4.3477 26.2749 3.57398 26.2749 3.13356 25.8078L0.348173 23.0048C-0.116058 22.5616 -0.116058 21.7829 0.348173 21.3158L14.2394 7.3367C14.7036 6.86953 15.4773 6.86953 15.9177 7.3367Z" />
    </svg>
  );
};

OptimisationIcon.displayName = "OptimisationIcon";

export default OptimisationIcon;
